import { render, staticRenderFns } from "./buy_n1.vue?vue&type=template&id=d4fe2be4&scoped=true&"
import script from "./buy_n1.vue?vue&type=script&lang=js&"
export * from "./buy_n1.vue?vue&type=script&lang=js&"
import style0 from "./buy_n1.vue?vue&type=style&index=0&id=d4fe2be4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4fe2be4",
  null
  
)

export default component.exports